<template>
	<b-modal id="ticketRequestRefundModal" :title="title" no-close-on-backdrop hide-footer @close="close()">
		<Loader :show="loading" type="inline" />

		<FormulateForm v-if="!loading" v-model="form" name="form" @submit="save">
			<!-- <p class="text-secondary">
				Envía tickets de cortesía a un usuario<br />
			</p> -->
			<div class="alert alert-secondary">
				<span></span>

				<div v-if="ticket.type == 'COURTESY'">
					Si no vas a utilizar el ticket, te agradecemos que lo canceles para poder dejarle lugar a otro
					asistente.
				</div>
				<div v-if="ticket.type == 'TICKET'">
					El organizador revisará tu solicitud de cancelación; en todos los casos, la tarifa de CobraTicket no
					es reembolsable y no se incluirá en el monto final de su reembolso.
				</div>
			</div>

			<div class="mt-3">
				<div class="label">Número de orden</div>
				<h6>{{ ticket.order.id }}</h6>
			</div>
			<div class="mt-4">
				<h6>Información de contacto</h6>

				<div class="d-flex">
					<div class="mt-2 mr-5">
						<div class="label text-secondary">Nombre</div>
						<p>{{ ticket.order.user.name }} {{ ticket.order.user.lastname }}</p>
					</div>
					<div class="mt-2">
						<div class="label text-secondary">Email</div>
						<p>{{ ticket.order.user.email }}</p>
					</div>
				</div>
			</div>
			<div class="mt-3">
				<FormulateInput
					label="Motivo de la cancelación"
					name="reason"
					type="select"
					:options="reasons"
					validation-name="Tipo de ticket"
					validation="required"
					optionValue="value"
					optionText="label"
				/>
			</div>
			<div class="mt-3">
				<FormulateInput
					label="Comentarios"
					type="textarea"
					name="comments"
					validation="required|max:200,length"
					validation-name="Mensaje"
					error-behavior="live"
					:help="`${200 - form.comments.length} restantes.`"
				/>
			</div>

			<hr />
			<div class="d-flex justify-content-between mt-4">
				<div class="btn btn-secondary" @click="close">
					Cancelar
				</div>
				<div class="btn btn-primary" @click="$formulate.submit('form')">
					<span v-if="saving">Enviando <span class="btn-loader" /> </span>
					<span v-else>Enviar solicitud</span>
				</div>
			</div>
		</FormulateForm>
	</b-modal>
</template>

<script>
import gql from "graphql-tag"
import Loader from "@/components/Loader"
export default {
	name: "EventTicketCourtesyForm",
	components: {
		Loader
	},
	data() {
		return {
			loading: true,
			saving: false,
			title: "Cancelar ticket",
			reasons: [
				{ value: null, label: "" },
				{ value: "Contagio o contacto positivo COVID-19", label: "Contagio o contacto positivo COVID-19" },
				{ value: "Evento cancelado o pospuesto", label: "Evento cancelado o pospuesto" },
				{ value: "Orden duplicada", label: "Orden duplicada" },
				{ value: "No puedo asistir", label: "No puedo asistir" },
				{ value: "Insatisfecho con el evento", label: "Insatisfecho con el evento" },
				{
					value: "Olvidé usar un código de descuento o promoción",
					label: "Olvidé usar un código de descuento o promoción"
				},
				{ value: "Compré la entrada equivocada", label: "Compré la entrada equivocada" },
				{ value: "Otro motivo", label: "Otro motivo" }
			],
			ticket: null,
			form: {
				reason: null,
				comments: ""
			}
		}
	},

	methods: {
		async open(ticketId) {
			this.$bvModal.show("ticketRequestRefundModal")
			await this.load(ticketId)
			this.loading = false
		},
		close() {
			this.$bvModal.hide("ticketRequestRefundModal")
			this.form = {
				reason: null,
				comments: ""
			}
			this.ticket = null
		},

		async save() {
			if (!this.saving) {
				this.saving = true
				let data = {
					reason: this.form.reason,
					comments: this.form.comments
				}

				await this.create(data)
				this.$emit("updated")
				this.close()
				this.saving = false
			}
		},

		async create(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: TicketRefundInput!) {
							ticketRefundRequest(id: $id, data: $data)
						}
					`,
					variables: {
						id: this.ticket.id,
						data
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.$toast.success("Solicitud enviada correctamente")
					this.saving = false
					this.$emit("updated")
					return data.ticketRefundRequest
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.saving = false
				})
		},

		load(id) {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							ticket(id: $id) {
								id
								currencySymbol
								price
								type
								holder {
									id
									name
									lastname
									email
								}
								ticketType {
									id
									name
									ticketGroup {
										id
										name
										event {
											id
											name
											startAt
											image {
												id
												url
												urlThumb
											}
										}
									}
								}

								order {
									id
									paidAt
									user {
										id
										name
										lastname
										email
									}
									status
								}
							}
						}
					`,
					variables: {
						id
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.ticket = data.ticket
					return data
				})
		}
	}
}
</script>

<style scoped>
.periods .period {
	display: flex;
}
</style>
